export default __webpack_public_path__ + "static/media/Tutorial-Step-1.34bfda08.jpg";